import React from 'react';
import { ReactNode } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';


import NavBar_v03Responsive_SUNDANCE_VENDING from './App_v01_SundanceVending_NavBar_v03a_Responsive_component';

import VendingMachinesVerticalPage  from './App_01_VendingMachines';

import HomePage_v01 from './App_v01_HomePage_v01_SundanceVending';
import VendingScoreCard_v01_2024_01_18_chat from './components/VendingScoreCard_v01_chat';

import { VendingMachineGallery_v01 } from "./App_v01_VendingMachines";
import { VendingMachineGallery_v02 } from "./App_v01_VendingMachines_v02";



//PRODUCT PICKER 
import  ProductPicker14GAE from './components/ProductPickerStash/ProductPicker_v14G-AE'
//import  ProductPickerV13ZN from './components/ProductPicker_v13ZN'





import About_v01 from '../component-library/AboutUs_Page_v01-component';
import { Footer_v01_Sundance  } from "../sundance-vending/App_v01_SundanceVending_Footer_v01a_component";

import Services_v01 from '../component-demos/stash/Services_v01';
//import Contact_v02 from '../component-library/ContactUs_Page_v02_A2P_component';//ORIGINAL PAGE WORKS AS OF 3/4/2026
import Contact_v02 from './APP_V01_ContactUs_Page_v02_A2P_MACHINE_FEEDBACK_FEB_2026_v02_receipt_component';
import MachineFeedback_v01 from './XXMACHINE_FEEDBACK_ContactUs_Page_v01_component';
import TestPage_v01 from './components/TestPage_v01';

import FAQs_Page_v01_MASTER_WithSUB from '../component-library/MASTER-COMPONENTS/FAQ_Page_v01_MASTER_WithSUB';
import LeftSideNavScrollSpy_v03 from '../component-demos/LeftSideNavBarScorllSpy_v03';
// import Footer_v01_Sundance from "../component-library/Footer_v01a_component";
import TermsOfService_Page_vending from "./components/legal_TermsOfService_Page_Vending_v01A_A2P";
import PrivacyPolicy_page_vending from "./components/legal_PrivacyPolicy_Page_Vending_v01a_A2P";

import ChatBot from "../component-library/ChatBOT_v01_component";
import { AppConfigData  } from "./App_v01_SundanceVending_ConfigData";

import { IAppConfig } from "../App_v01_Interfaces";
interface AppConfigProps{
  appConfig: IAppConfig;
}



  

const AppRouts_v01: React.FC = () => {

  return (
    <Router>
            <div className="d-flex flex-column min-vh-100 justify-content: flex-start">
              <NavBar_v03Responsive_SUNDANCE_VENDING appConfig={AppConfigData} />
        
                <main className="flex-fillx">
                  <Routes>
                      <Route path="/" element={<HomePage_v01 appConfig={AppConfigData} />} />
                      <Route path="*" element={<HomePage_v01 appConfig={AppConfigData} />} />
                      <Route path="/faq"      element={<FAQs_Page_v01_MASTER_WithSUB faqDataDocument={AppConfigData.faqData} />} />
                      <Route path="/about"    element={<About_v01 appConfig={AppConfigData} />} />
                      <Route path="/contact"  element={<Contact_v02 appConfig={AppConfigData} />} />
                      <Route 
                      path="/machinefeedback/:machineId"
                      element={<MachineFeedback_v01 appConfig={AppConfigData} />} />
                        <Route 
                      path="/machinefeedback"
                      element={<MachineFeedback_v01 appConfig={AppConfigData} />} />
                      
                      <Route path="/products"  element={<ProductPicker14GAE />} />
                      
                      <Route path="/scorecard"  element={<VendingScoreCard_v01_2024_01_18_chat />} />
                      
                      <Route path="/vend1"  element={<VendingMachineGallery_v01 />} />
                      <Route path="/vend2"  element={<VendingMachineGallery_v02 />} />
                      <Route path="/vend3"  element={<VendingMachinesVerticalPage />} />
                      

                      
                      
                      <Route path="/services" element={<Services_v01 appConfig={AppConfigData} />} />
                      <Route path="/leftnav"  element={<LeftSideNavScrollSpy_v03 />} />\
                      <Route path="/googleSPDemov01" element={<LeftSideNavScrollSpy_v03 />} />
                      <Route path="/tos"      element={<TermsOfService_Page_vending appConfig={AppConfigData}/>} />
                      <Route path="/privacy"  element={<PrivacyPolicy_page_vending appConfig={AppConfigData} />} />
                      <Route path="/chatBot"  element={<ChatBot />} /> 

      
                      <Route path="/testpage" element={<TestPage_v01 appConfig={AppConfigData} />} />
                      
                      {/* <Route path="/faq2" element={<theVendingFAQ_v02a />} /> */}
                      
                  </Routes>
                </main>
                <Footer_v01_Sundance appConfig={AppConfigData}/>
              </div>
    </Router>
  );
};





// const App_v01: React.FC = () => {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<HomePage_v01 />} />
//         <Route path="/about" element={<About_v01 />} />
//         <Route path="/services" element={<Services_v01 />} />
//         <Route path="/contact" element={<Contact_v01 />} />
//         <Route path="/faq" element={<FAQs_Page_v01 />} />
//         <Route path="/leftnav" element={<LeftSideNavScrollSpy_v03 />} />\
//         <Route path="/googleSPDemov01" element={<LeftSideNavScrollSpy_v03 />} />
       
//       </Routes>
//     </Router>
//   );
// };

export default AppRouts_v01;
